import { Route } from '@angular/router';

export const OrderRoutes: Route[] = [
  {
    path: 'order',
    children: [
      {
        path: '',
        loadComponent: () => import('../pages/order/order.page'),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('../pages/order/order-detail/order-detail.page'),
      },
    ],
  },
];
